import React from 'react';
import {
  createStyles,
  Theme,
  ThemeProvider,
  withStyles,
  WithStyles,
} from '@material-ui/core';

import { Container, units } from '@ha/dsl';
import { sourceSansHeaders as sharpSansHeadersFont } from 'ha/constants/fonts/sourceSansHeaders';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

import { HermesData } from '../types';
import { Layout } from './Layout';
import { MobileLayout } from './MobileLayout';

const blogNextTheme: (outerTheme: Theme) => Theme = outerTheme => ({
  ...outerTheme,
  typography: {
    ...outerTheme.typography,
    h1: {
      ...outerTheme.typography.h1,
      fontFamily: sharpSansHeadersFont.fontFamily,
    },
  },
});

export const styles = (t: Theme) =>
  createStyles({
    root: {
      backgroundColor: t.palette.grey['50'],
      padding: units.txb(2.5, 1.5, 5),
      [t.breakpoints.up('lg')]: {
        padding: units.txb(2.5, 0, 7.5),
      },
    },
  });

interface Props {
  data: HermesData;
  isCTADisabled: boolean;
}

const BlogInternal: React.FC<Props & WithStyles<typeof styles>> = ({
  data,
  isCTADisabled,
  classes,
}) => {
  const { lg } = useMediaQuery();

  return (
    <ThemeProvider theme={blogNextTheme}>
      <div className={classes.root}>
        <Container maxWidth="lg">
          {lg ? (
            <Layout data={data} isCTADisabled={isCTADisabled} />
          ) : (
            <MobileLayout data={data} isCTADisabled={isCTADisabled} />
          )}
        </Container>
      </div>
    </ThemeProvider>
  );
};

const Blog = withStyles(styles)(BlogInternal);
export { Blog };
